/**
 * Page Loader - Hides the page loader when the page is fully loaded
 */

export const initLoader = () => {
  const loader = document.getElementById('page-loader');

  if (!loader) return;

  // Hide loader when page is fully loaded
  window.addEventListener('load', () => {
    loader.classList.add('is-hidden');

    // Remove loader from DOM after transition
    setTimeout(() => {
      loader.style.display = 'none';
    }, 600);
  });

  // Fallback: hide loader after 3 seconds even if load event doesn't fire
  setTimeout(() => {
    if (!loader.classList.contains('is-hidden')) {
      loader.classList.add('is-hidden');
      setTimeout(() => {
        loader.style.display = 'none';
      }, 600);
    }
  }, 3000);
};
